<ng-container *ngIf="flexibleFields.length">
  <div class="menu-container" *ngIf="from == 'Details'">
    <div class="row menu-row-container">
      <div class="col-sm-6 gridName-container">
        <span class="gridName">Additional Details</span>
      </div>
    </div>
  </div>

  <div class="row" style="margin-top: 5px;">
    <div
      [ngClass]="(field.fieldType == 'Large Text' || field.fieldType == 'Multiselect Drop Down') ? 'col-md-6' : 'col-md-3'"
      *ngFor="let field of flexibleFields; let i = index;">
      <!-- Label -->
      <div class="col-md-12" style="margin-top: 5px;">
        <label for="name" id={{i}}>{{ field.fieldName }}</label>
        <span *ngIf="field.isMandatory == 'Y' && from == 'Details'" class="mandatory-symbol">*</span>
      </div>

      <!-- Field UI -->
      <div class="col-md-12">
        <ng-container [ngSwitch]="field.fieldType">
          <!-- Text Field -->
          <ng-container *ngSwitchCase="'Text Field'">
            <ng-container
              *ngIf="field.fieldDatatype !='Date' && field.fieldDatatype !='Number' && field.fieldDatatype !='Datetime'">
              <input class="input-filed-continers" type="text" [(ngModel)]="field.fieldDefaultValue"
                [matTooltip]="field.instructions" matTooltipPosition="below" [matTooltipShowDelay]="300"
                [matTooltipHideDelay]="100" matTooltipClass="custom-tooltip" [disabled]="getDisabled(field)"
                (ngModelChange)="onNgModelChange(field, i + '')">
            </ng-container>

            <ng-container *ngIf="field.fieldDatatype =='Number'">
              <input class="input-filed-continers" type="number" [(ngModel)]="field.fieldDefaultValue"
                [matTooltip]="field.instructions" matTooltipPosition="below" [matTooltipShowDelay]="300"
                [matTooltipHideDelay]="100" matTooltipClass="custom-tooltip" [disabled]="getDisabled(field)"
                (ngModelChange)="onNgModelChange(field, i + '')">
            </ng-container>

            <ng-container *ngIf="field.fieldDatatype =='Date'">
              <input type="text" class="form-control data-picker-continer" placement="top" bsDatepicker
                [matTooltip]="field.instructions" matTooltipPosition="below" [matTooltipShowDelay]="300"
                [matTooltipHideDelay]="100" matTooltipClass="custom-tooltip" [disabled]="getDisabled(field)"
                [bsConfig]="$getDateConfig(field)" [dateCustomClasses]="dateCustomClasses"
                [container]="'#datepickerContainer'" [(ngModel)]="field.fieldDefaultValue"
                (ngModelChange)="onNgModelChange(field, i + '')">
            </ng-container>

            <ng-container *ngIf="field.fieldDatatype =='Datetime'">
              <input type="text" class="form-control datatime-picker-continer" placement="top" bsDatepicker
                #datePicker="bsDatepicker" [bsConfig]="$getDateTimeConfig(field)"
                [dateCustomClasses]="dateCustomClasses" [container]="'#datepickerContainer'"
                [(ngModel)]="field.fieldDefaultValue"
                (ngModelChange)=" field.fieldDefaultValue != null ? onDateChange(datePicker) : ''"
                [matTooltip]="field.instructions" matTooltipPosition="below" [matTooltipShowDelay]="300"
                [matTooltipHideDelay]="100" matTooltipClass="custom-tooltip" [disabled]="getDisabled(field)"
                (ngModelChange)="onNgModelChange(field, i + '')">
            </ng-container>
          </ng-container>

          <!-- Large Text -->
          <textarea *ngSwitchCase="'Large Text'" class="input-filed-textarea" rows="4"
            [(ngModel)]="field.fieldDefaultValue" [disabled]="getDisabled(field)" [matTooltip]="field.instructions"
            matTooltipPosition="below" [matTooltipShowDelay]="300" [matTooltipHideDelay]="100"
            matTooltipClass="custom-tooltip" (ngModelChange)="onNgModelChange(field, i + '')"></textarea>

          <!-- Drop Down -->
          <mat-select *ngSwitchCase="'Drop Down'" [(ngModel)]="field.fieldDefaultValue" [disabled]="getDisabled(field)"
            placeholder="Select" (closed)="dropDownSearchText=''" (click)="focusSearch('dd-search')"
            (keydown.enter)="focusSearch('dd-search')" [matTooltip]="field.instructions" matTooltipPosition="below"
            [matTooltipShowDelay]="300" [matTooltipHideDelay]="100" matTooltipClass="custom-tooltip">
            <input matInput type="dd-search" [(ngModel)]="dropDownSearchText" class="dropdownsearchstyle"
              placeholder="Search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onDropdownSelect($event, field, i + '');">Un-select</mat-option>
            <mat-option *ngFor="let item of field.fieldLovValues | assessmentSearch : dropDownSearchText" [value]="item"
              (onSelectionChange)="onDropdownSelect($event, field, i + '');">
              {{ item }}
            </mat-option>
          </mat-select>

          <!-- Multiselect Drop Down -->
          <mat-select *ngSwitchCase="'Multiselect Drop Down'" multiple #multiselect
            [attr.data-field-id]="field.fieldLovValues" [(ngModel)]="field.dd" [disabled]="getDisabled(field)"
            placeholder="Select" (closed)="dropDownSearchText=''" (click)="focusSearch('search')"
            (keydown.enter)="focusSearch('search')" [matTooltip]="field.instructions" matTooltipPosition="below"
            [matTooltipShowDelay]="300" [matTooltipHideDelay]="100" matTooltipClass="custom-tooltip">
            <input matInput type="search" [(ngModel)]="dropDownSearchText" placeholder="Search"
              class="dropdownsearchstyle">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="field.multiSelection" [disabled]="false"
                (change)="toggleAllSelection('multiselect', field, i + '');">
                Select All
              </mat-checkbox>
            </div>
            <mat-option (onSelectionChange)="onMultiSelect($event, field, i + '');"
              *ngFor="let q of field.fieldLovValues | assessmentSearch : dropDownSearchText" [value]="q">
              {{ q }}
            </mat-option>
          </mat-select>

          <!-- Vertical Radio Button -->
          <mat-radio-group *ngSwitchCase="'Vertical Radio Button'" [(ngModel)]="field.fieldDefaultValue"
            [disabled]="getDisabled(field)" class="d-flex flex-column" [matTooltip]="field.instructions"
            matTooltipPosition="below" [matTooltipShowDelay]="300" [matTooltipHideDelay]="100"
            matTooltipClass="custom-tooltip" (ngModelChange)="onNgModelChange(field, i + '')">
            <mat-radio-button *ngFor="let val of field.fieldLovValues" [value]="val">
              {{ val }}
            </mat-radio-button>
          </mat-radio-group>

          <!-- Horizontal Radio Button -->
          <mat-radio-group *ngSwitchCase="'Horizontal Radio Button'" [(ngModel)]="field.fieldDefaultValue"
            [disabled]="getDisabled(field)" class="d-inline-flex" [matTooltip]="field.instructions"
            matTooltipPosition="below" [matTooltipShowDelay]="300" [matTooltipHideDelay]="100"
            matTooltipClass="custom-tooltip" (ngModelChange)="onNgModelChange(field, i + '')">
            <mat-radio-button *ngFor="let val of field.fieldLovValues" [value]="val">
              {{ val }}
            </mat-radio-button>
          </mat-radio-group>

          <!-- Vertical Checkbox Button -->
          <ng-container *ngSwitchCase="'Vertical Checkbox Button'" [matTooltip]="field.instructions"
            matTooltipPosition="below" [matTooltipShowDelay]="300" [matTooltipHideDelay]="100"
            matTooltipClass="custom-tooltip">
            <section *ngFor="let val of field.fieldLovValues" class="d-flex flex-column">
              <mat-checkbox (change)="onCheckboxChange($event, val, field);" [checked]="field.dd.indexOf(val) !== -1"
                [disabled]="getDisabled(field)">
                {{ val }}
              </mat-checkbox>
            </section>
          </ng-container>

          <!-- Horizontal Checkbox Button -->
          <ng-container *ngSwitchCase="'Horizontal Checkbox Button'" [matTooltip]="field.instructions"
            matTooltipPosition="below" [matTooltipShowDelay]="300" [matTooltipHideDelay]="100"
            matTooltipClass="custom-tooltip" style="align-items: center;">
            <section *ngFor="let val of field.fieldLovValues" class="d-inline-flex">
              <mat-checkbox [checked]="field.dd.indexOf(val) !== -1" [disabled]="getDisabled(field)"
                (change)="onCheckboxChange($event, val, field);">
                {{ val }}
              </mat-checkbox>
            </section>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>

  <div style="margin-top: 5px; margin-bottom: 7px;" class="d-flex justify-content-center"
    *ngIf="from == 'Details' && !getDisabled(0)">
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="save('flexible', qualityService.activityId)">
        <i class="fas fa-user-edit"></i> Save Additional Details
      </button>
    </div>
  </div>
</ng-container>
